import { getConfig } from "@/config";

const config = getConfig();
export const ENVIRONMENT = config.ENV;
export const BACKEND_URL = config.BACKEND_URL;
export const API_ID = config.API_ID;
export const TENANT = config.TENANT;
export const CLIENT_ID = config.CLIENT_ID;
export const SENTRY_DSN = config.SENTRY_DSN;
export const STOCK_PRICE_TTL = config.STOCK_PRICE_TTL;
export const BASE_URL = config.FRONTEND_URL;

export const CURRENT_YEAR = new Date().getFullYear();
export const HOUSEHOLD_GRID_TOO_MANY_RESULTS = 3;
export const HOUSEHOLD_GRID_MIN_SEARCH_LENGTH = 3;

export const SESSION_STORAGE_KEYS = {
  REDIRECT_PATH: "redirectPath",
};

export const TOAST_VERSION_KEY = "toastVersionKey";
export const MINIMAL_BACKEND_VERSION = "1.5.0";

export const UNIQUE_POSSIBILITIES = {
  MaxAge: 110,
  MinAge: 62,
  SocialSecurityAgeList: Array.from({ length: 110 - 62 + 1 }, (_, i) => i + 62),
};

export const IS_PRODUCTION =
  typeof window !== "undefined" && ENVIRONMENT?.toLocaleLowerCase().includes("prod");

export const IS_DEVELOPMENT =
  (typeof window !== "undefined" && ENVIRONMENT?.toLocaleLowerCase().includes("dev")) ||
  import.meta.env.DEV;
